module.exports = __webpack_public_path__ + "img/J7.9ad63844.png";